import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {},

  categoryContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    columnGap: '30px',
    overflowX: 'auto',
    [theme.breakpoints.up('md')]: {
      width: '550px',
    },
    [theme.breakpoints.up(1000)]: {
      width: '600px',
    },

    [theme.breakpoints.up('lg')]: {
      width: '700px',
    },
    [theme.breakpoints.up(1330)]: {
      width: '100%',
    },
  },

  category: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: '10px',
  },

  imgWrapper: {
    position: 'relative',
    width: '230px',
    height: '147px',
    borderRadius: '15px',
    overflow: 'hidden',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      width: '250px',
      height: '160px',
    },
  },
});
